<template>
  <CSidebar 
    fixed
    aside
    :show="show"
    :color-scheme="this.$store.state.theme_mode"
    overlaid
    dropdownMode="closeInactive"
    @update:show="(value) => $store.commit('set', ['anotherSidebarShow', value])"
  >

    <CNav variant="tabs">
      <CButton  @click="$store.commit('toggleAnotherSidebar')"><CIcon name="cil-x"/></CButton>

      <CNavItem>Link</CNavItem>
      <CNavItem>Another Link</CNavItem>
      <CNavItem disabled>Disabled</CNavItem>
    </CNav>
    <CRow>
      <CCol></CCol>
      <CCol></CCol>
      <CCol></CCol>

    </CRow>


  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheAnotherSidebar',
  nav,
  data() {
    return {
      title_top:localStorage.getItem("app_name"),
    }
  },
  computed: {

    show () {
      return this.$store.state.anotherSidebarShow
    },


  },
  mounted() {
    // this.generate_nav();
  // console.log("sidebar  = ",this.$refs['sidebar_ref'].$children[0].$children[0].$children[2].$el.classList.remove("c-show"));
  //   this.$refs['sidebar_ref'].$children[0].$children[0].$children.forEach((val) => {
  //    val.$el.classList.remove("c-show");
  //   });
  },methods:{
     clicked(state){
      console.log(state)
}
  }
}
</script>
